export default {
    config: function () {
        var config = {
            checkUrl: "/modules/point/yescoin/check",
            redeemUrl: "/modules/point/yescoin/redeem",
            redeemUrlSpecial: {
                'lineCiti': '/modules/point/yescoin/citi',
            }
        }
        return config;
    },
}

export const BitkubConfig = {
    endpoint: "https://accounts.bitkubnext.com",
    clientId: "6274a88df5c1ee5fad18a3fb",
    redirectUri: "/bitkub/callback",
    apiUrl: "https://api.bitkubnext.io",
}
